// 配置全局访问接口地址
let commonUrl = "//fuyin.ykpm18.com";
// let commonUrl = "//www.touzi.test";

 
let baseUrl = {
    commonUrl
}
 
export default baseUrl